import Papa from "papaparse";
//import { stringify } from 'csv-stringify/lib/sync'
import React, { useState } from "react";
import { ErrorBoundary } from "storybook-dashboard/errors";
import Swal from "sweetalert2";
import { alertSuccess } from "traec-react/utils/sweetalert";
import Im from "immutable";
import { doFetch, fetcher } from "storybook-dashboard/utils/fetching";
import { getPtr } from "../reportDocumentRow";
import { mergeNodes } from "storybook-dashboard/utils";

export const HeaderButtons = (props) => {
  let { setData, data, trackerId, commitId, fields, filename, doc, path, readOnly, formTemplate, assignments } = props;

  if (readOnly) {
    return null;
  }

  let templateLink = formTemplate?.get("url");
  let templateName = formTemplate?.get("name");

  return (
    <ErrorBoundary>
      {/* <Explanation show={templateLink} /> */}
      {/* <DownloadTemplateButton templateLink={templateLink} templateName={templateName} /> */}
      {/* <UploadCSVButton setData={setData} data={data} /> */}
      {/* <input style={{ display: "none" }} type="file" id="file-selector" /> */}
      <SaveButton
        fields={fields}
        data={data}
        doc={doc}
        path={path}
        filename={filename}
        trackerId={trackerId}
        commitId={commitId}
        assignments={assignments}
      />
      {/* <ClearButton setData={setData} /> */}
    </ErrorBoundary>
  );
};

const DownloadTemplateButton = (props) => {
  let { templateLink, templateName } = props;

  if (!templateLink) {
    return null;
  }

  return (
    <a className="btn btn-sm btn-warning pt-0 pb-0 ml-1 mr-1 mb-2" href={templateLink} download={templateName}>
      Download Template
    </a>
  );
};

const ClearButton = (props) => {
  let { setData } = props;

  return (
    <button className="btn btn-danger float-right mr-2" onClick={(e) => setData(Im.List())}>
      Delete all
    </button>
  );
};

const UploadCSVButton = (props) => {
  let { setData, data } = props;

  return (
    <>
      <button
        className="btn btn-sm btn-primary pt-0 pb-0 ml-1 mr-1 mb-2"
        onClick={(e) => {
          e.preventDefault();
          $("#file-selector").on("change", (e) => {
            console.log("Selected files", e.target.files);
            console.log("Parsing CSV file");
            Papa.parse(e.target.files[0], {
              skipEmptyLines: "greedy",
              complete: (results) => {
                let headers = results.data[0];
                let newData = results.data
                  .slice(1)
                  .map((row) => headers.reduce((acc, cur, i) => Object.assign(acc, { [cur]: row[i] }), {}));
                setData(data.concat(Im.fromJS(newData)));
              },
            });
          });
          $("#file-selector").trigger("click");
        }}
      >
        Upload from CSV
      </button>
    </>
  );
};

const Explanation = (props) => {
  let { show } = props;

  if (!show) {
    return (
      <>
        <p>
          Either complete the table below manually by adding a new row for each employee or follow the steps below to
          upload your data from a CSV file:
        </p>
        <ul>
          <li>
            <b>Step 1</b>: Click the "Upload from CSV" button and upload the CSV
          </li>
          <li>
            <b>Step 2</b>: Press the "Save" button to save the data
          </li>
        </ul>
        <p>
          Please ensure that the CSV file upload has the heading columns that match the table headers below.
          <br />
          Row reference populates automatically from the upload CSV and will help you identify errors within specific
          rows of data.
        </p>
        <p style={{ fontWeight: "bold" }}>
          For manual entry, please add all information needed and don't forget to click “Add” for each data entry row
          before you click “Save”.
        </p>
      </>
    );
  }

  return (
    <>
      <p>
        Either complete the table below manually by adding a new row for each employee or follow the steps below to
        upload your data from a CSV file:
      </p>
      <ul>
        <li>
          <b>Step 1</b>: Download the Excel template
        </li>
        <li>
          <b>Step 2</b>: Save the completed Excel templates as a .CSV file
        </li>
        <li>
          <b>Step 3</b>: Click the "Upload from CSV" button and upload the CSV
        </li>
        <li>
          <b>Step 4</b>: Press the "Save" button to save the data
        </li>
      </ul>
      <p>
        Please ensure that the CSV file upload has the heading columns that match the table headers below.
        <br />
        Row reference populates automatically from the upload CSV and will help you identify errors within specific rows
        of data.
      </p>
      <p style={{ fontWeight: "bold" }}>
        For manual entry, please add all information needed and don't forget to click “Add” for each data entry row
        before you click “Save”.
      </p>
    </>
  );
};

export const SaveButton = (props) => {
  let {
    fields,
    data,
    doc,
    path,
    trackerId,
    commitId,
    filename,
    assignments,
    btnName,
    setDisplaySaveBtn,
    fetches,
    closeModal,
    modalId,
  } = props;
  const [pending, setPending] = useState(false);
  const SpinningButton = () => {
    return <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>;
  };

  return (
    <button
      className="btn btn-primary float-right mr-1 mb-2"
      disabled={pending}
      onClick={(e) => {
        e.preventDefault();

        let text = dataToCSVText(fields, data);
        uploadFile(
          textToFormData({ text, path, filename }),
          {
            trackerId,
            commitId,
            doc,
            path,
            setPending,
            saveSuccessHandler: assignments ? saveSuccessHandler : closeModal,
          },
          fetches
        );
        setDisplaySaveBtn(false);
        $(`#${modalId}`).modal("hide");
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
      }}
    >
      {pending ? <SpinningButton /> : btnName ? btnName : "Save changes"}
    </button>
  );
};

export const dataToCSVText = (fields, data) => {
  console.log("fields in datatocsv", fields?.toJS());
  let headers = fields.map((field) => field.get("header"));
  let lines = [];
  //lines.push(headers.join(","));
  lines.push(headers?.toJS());
  console.log("data in datatocsv", data?.toJS());
  console.log("headers in datatocsv", headers?.toJS());
  data.map((row) => {
    console.log("row in datatocsv", row?.toJS());
    lines.push(headers.map((header) => row.get(header) || "")?.toJS()); //.join(",")
  });
  //return lines.join("\n");
  //let output = stringify(lines)
  let output = Papa.unparse(lines);
  console.log("Got CSV data output", output);
  return output;
};

export const textToFormData = ({ text, path, filename = "data.csv" }) => {
  let formData = new FormData();
  const blob = new Blob([text], { type: "text/csv" });
  formData.append("fileobj", blob, filename);
  formData.append("type", "document");
  formData.append("path", path);
  console.log("Packaged csv text as blob in multipart file object", text);
  return formData;
};

export const uploadFile = (formData, props, fetches) => {
  /* You can send this as a raw file if you set:
    headers: { "content-type": null: "content-disposition": "attachment; filename=upload.jpg" },
    body: this.state.selectedFiles[0]
    */
  let { trackerId, commitId, refId, path: pathId, setPending, saveSuccessHandler } = props;

  let { ptr, ptrId } = getPtr({ commitId, refId });
  if (setPending) setPending(true);
  fetcher(`/api/tracker/${trackerId}/${ptr}/${ptrId}/node/${pathId}/`, "PUT", formData).then(({ payload }) => {
    if (setPending) setPending(false);
    if (saveSuccessHandler) {
      let currentDocObject = payload
        .filter((i) => i.get("type") == "documentstatus")
        .first()
        ?.getIn(["node", "documentstatus", "current_object"]);
      console.log("Running saveSucessHandler", currentDocObject?.toJS(), props);
      saveSuccessHandler({
        ...props,
        currentDocObject,
      });
    }
    const { mutate, data } = fetches.nodes;
    mutate(mergeNodes(data, payload?.toJS())); // 3rd agument updates the cache without refetching & prevents modal bugs.
  });
};

export const saveSuccessHandler = (props) => {
  Swal.fire({
    title: "Form data saved",
    text: "Your form data has been saved successfully.  Do you wish to auto-complete the report from the saved data?",
    type: "success",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Auto-fill report from data provided",
    cancelButtonText: "No, continue to edit data table",
  }).then((result) => {
    if (result.value) {
      fetchAssignToMetricValues(props);
    } else {
      console.log("Not doing auto-assignment.");
    }
  });
};

export const fetchAssignToMetricValues = ({ trackerId, commitId, doc, currentDocObject }) => {
  doFetch(`/api/tracker/${trackerId}/dispatch/`, "POST", {
    type: "CSV_TO_INPUT_VALUES",
    payload: {
      commitId,
      fileId: currentDocObject?.get("uid"),
      docId: doc?.get("uid"),
    },
  }).then((e) => {
    alertSuccess({
      title: "Report auto-filled",
      text: "Your report has been auto-completed based on the spreadsheet data provided. The browser will now refresh.",
      onConfirm: () => {
        window.location.reload();
      },
    });
  });
};
